export default "__VITE_ASSET__CrxzZl2o__"